  <template>
   <div>
    <form @submit.prevent="false">
        <div class="form-container">
            <div class="vx-row" v-if="selectedIItem == null">    
                  <div class="vx-col pb-5" @keyup="formerrors.msg=''" @click="formerrors.msg=''"  v-if="showActionBtn">
                      <div class="custom-radio custom-radio_btns" >  
                                
                      <vs-radio class="mr-6"  v-model="wiseSelection" vs-value="true" @change="updateSelection()">Create Account for Beneficiary</vs-radio>
                      <vs-radio v-model="wiseSelection" vs-value="false"  @change="updateSelection()">Continue without Account</vs-radio>
                      </div> 
                  </div>
                </div>
               
                  <div class="vx-row" @keyup="formerrors.msg=''" @click="formerrors.msg=''" >

                    <div class="vx-col w-1/2">
                      <div class="form_group">
                       
                        <label class="form_label">First Name<em>*</em></label>
                        <vs-input :key="'beneficiaryname'"
                          v-model="beneficiary.firstName"
                          name="beneficiaryname"
                          data-vv-as="First Name"
                          v-validate="'required'"
                          class="w-full" />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('beneficiaryname')"
                        >{{ errors.first("beneficiaryname") }}</span>
                      </div>
                    </div>
                    <div class="vx-col w-1/2">
                      <div class="form_group">
                        <label class="form_label">Last Name<em>*</em></label>
                        <vs-input :key="'beneficiarylastname'"
                          v-model="beneficiary.lastName"
                          name="beneficiarylastname"
                          data-vv-as="Last Name"
                          v-validate="'required'"
                          class="w-full" />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('beneficiarylastname')"
                        >{{ errors.first("beneficiarylastname") }}</span>
                      </div>
                  
                    </div>
                    <template v-if="!anonymousUser" >
                    <div class="vx-col w-1/2">
                      <div class="form_group">
                        <label class="form_label">Email<em v-if="!anonymousUser">*</em></label>
                        <vs-input :key="'beneficiaryemail'"
                          class="w-full"
                          name="beneficiaryemail"
                          v-model="beneficiary.email"
                          :disabled="editEmailTrue"
                          data-vv-as="Email"
                          v-validate="{'required':!anonymousUser ,'email':true}"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('beneficiaryemail')"
                        >{{ errors.first("beneficiaryemail") }}</span>
                      </div>
                    </div>
                 
                    <!-- <immiPhone :fieldsArray="['cell_phone_number']" :display="true" @updatephoneCountryCode="updatecellPhoneCountryCode" :countrycode="checkProperty(beneficiary ,'phoneCountryCode' ,'countryCode')" cid="bencellPhoneNumber"   v-model="beneficiary.phone"  :required="true" fieldName="cell_phone_number" label="Phone Number" placeHolder="Phone Number" /> -->
                    <!-- <em v-if="!anonymousUser">*</em>
                    {'required':!anonymousUser} -->
                  
                    <div class="vx-col w-1/2">
                      <div class="form_group ph_number">
                        <label class="form_label">Phone Number</label>
                        <div class="vs-component">                  
                          <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              v-validate="''"
                                key="phone"
                                v-bind="vuePhone.props"
                              data-vv-as="Phone Number"
                              name="phone"
                              :default-country-code="checkProperty(beneficiary['phoneCountryCode'] ,'countryCode')"
                              placeholder="Phone Number"
                              :no-country-selector="false"
                            v-model="beneficiary.phone" 
                              @update="updatePhone"
                              :preferred-countries="['US', 'IN']"
                              />
                          <span class="text-danger text-sm"   v-show="!isPhoneValid && !errors.has('phone')" >*Invalid phone number - Please enter a valid one</span>
            
                          <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first("phone") }}</span>

                        

                        </div>
                      </div>
                    </div>
                    </template>
                    
                    <template v-if="(checkBeneficaryInvitePermisions && getTenantTypeId !=2 ) && selectedIItem == null && [50].indexOf(getUserRoleId)<=-1 && [2, 4, 11].indexOf(checkProperty(visatype,'id'))<0"> 
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                              <label class="form_label">Select Petitioner</label>
                             
                                <multiselect
                                  v-model="selectedPetitioner"
                                  :options="petitionersList"
                                  :multiple="false" 
                                  :hideSelected="false"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  :select-label="'Search Petitioner'"
                                  placeholder="Select Petitioner"
                                  label="name"
                                  track-by="name"
                                  :preselect-first="false"
                                  name="Petitioner"
                                   data-vv-as="Petitioner"
                                   v-validate="[2].indexOf(checkProperty(visatype,'id'))>-1?'':'required'"
                                     tag-placeholder="Invite Petitioner"
                                  
                                  :searchable="true"
                                   @search-change="searchPet" 
                                
                                  >
                                
                                  <template slot="selection" slot-scope="{ values, isOpen }">
                                    <span
                                    class="multiselect__selectcustom"
                                    v-if="values.length && !isOpen"
                                    >{{ values.length }} options selected</span
                                    >
                                    <span
                                    class="multiselect__selectcustom"
                                    v-if="values.length && isOpen"
                                    ></span>
                                  </template>
                                </multiselect>
                              </div>
                              <span class="text-danger text-sm"  v-show="errors.has('Petitioner')">{{ errors.first("Petitioner") }}</span>
                            
                            </div> 
                            <p class="createnew">Not found?<span  @click="addNewPet()">Invite Client</span> </p> 
                            
                          </div>

                    </template>
                    <template v-if="checkProperty(visatype,'id')==4 && (checkBeneficaryInvitePermisions && getTenantTypeId !=2 ) && selectedIItem == null && [50].indexOf(getUserRoleId)<=-1"> 
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                              <label class="form_label">Select Sponsor</label>
                              <multiselect
                                  v-model="sponsor"
                                  :options="sponsorList"
                                  :multiple="false" 
                                  :hideSelected="false"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  :select-label="'Search Sponsor'"
                                  placeholder="Select Sponsor"
                                  label="name"
                                  track-by="name"
                                  :preselect-first="false"
                                  name="Sponsor"
                                   data-vv-as="Sponsor"
                                   v-validate="'required'"
                                     tag-placeholder="Invite Sponsor"
                                  
                                  :searchable="true"
                                   @search-change="searchspnsr" 
                                
                                  >
                                
                                  <template slot="selection" slot-scope="{ values, isOpen }">
                                    <span
                                    class="multiselect__selectcustom"
                                    v-if="values.length && !isOpen"
                                    >{{ values.length }} options selected</span
                                    >
                                    <span
                                    class="multiselect__selectcustom"
                                    v-if="values.length && isOpen"
                                    ></span>
                                  </template>
                                </multiselect>
                                
                                  <template slot="selection" slot-scope="{ values, isOpen }">
                                    <span
                                    class="multiselect__selectcustom"
                                    v-if="values.length && !isOpen"
                                    >{{ values.length }} options selected</span
                                    >
                                    <span
                                    class="multiselect__selectcustom"
                                    v-if="values.length && isOpen"
                                    ></span>
                                  </template>
                                
                            
                              </div>
                              <span class="text-danger text-sm"  v-show="errors.has('Sponsor')">{{ errors.first("Sponsor") }}</span>
                            
                            </div> 
                            <p v-if="!fromAdminIndDetails" class="createnew">Not found?<span  @click="addSoponser()">Invite Sponsor</span> </p> 
                            
                          </div>

                    </template>
               
                  
                  </div>
                  <div class="text-danger text-sm formerrors" v-show="formerrors.msg">
                          <vs-alert
                            color="warning"
                            class="warning-alert reg-warning-alert no-border-radius"
                            icon-pack="IntakePortal"
                            icon="IP-information-button"
                            active="true"
                          >{{ formerrors.msg }}</vs-alert>
                    </div> 
        </div>
        <div class="popup-footer relative">
          <figure v-if="saveBenbtn" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
        <vs-button color="dark" @click="selectedBeneficiary =null;closeAddBenPopUp();AddBeneficiary=false ;saveBenbtn=false" class="cancel" type="filled">Cancel</vs-button>
        <vs-button v-if="selectedIItem !=null" color="success" :disabled="saveBenbtn" @click="updatebeneficiary" class="save" type="filled">Update</vs-button>
        <vs-button v-if="selectedIItem ==null" color="success" :disabled="saveBenbtn" @click="savebeneficiary" class="save" type="filled">Submit</vs-button>

        </div>

    </form>


    <vs-popup style="z-index:99999999999" class="holamundo main-popup" :title="'User Already Existing'" :active.sync="userConform">
      <!-- (checkProperty(selectedUser,'statusId') ==2?'Inactivate ':' Activate')+' User' -->
      <div class="form-container">

        <div class="vx-row">
          <div class="vx-col w-full">
            <p>{{ userConformMsg }}</p>
          </div>

        </div>

        <div v-show="userConformErrorMsg">
          <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
            icon="IP-information-button" active="true">{{ userConformErrorMsg }}</vs-alert>
        </div>

      </div>
      <div class="popup-footer relative">
        
        <figure  class="loader" v-if="loading"> <img src="@/assets/images/main/loader.gif" />  </figure>
        <vs-button color="dark" class="cancel" type="filled" @click="userConform = false">Cancel </vs-button>
      <vs-button  color="success" class="save" :disabled="loading" type="filled"
          v-on:click.stop.prevent="userConformActivate()">
          Activate
        </vs-button>
        
      </div>
    </vs-popup>
    </div>
  
</template>


<script>


import Datepicker from "vuejs-datepicker-inv";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from 'moment'
import PhoneMaskInput from "vue-phone-mask-input";
import * as _ from "lodash";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';  

import immiPhone from "@/views/forms/fields/phonenumber.vue";

export default {
  provide() {
        return {
            parentValidator: this.$validator,
        };
    },

  components: {
    immiPhone,
    VuePhoneNumberInput,
    Datepicker,
    DateRangePicker,
    moment,
    PhoneMaskInput
  },
  data: () => ({
    editEmailTrue:false,
    userConform:false,
    userConformMsg:'',
    userConformErrorMsg:'',
    conformUserId:'',
    loading: false,

    anonymousUser:false,
    wiseSelection:'true',
    selectedBeneficiary:null,
    count:0,
    vuePhone:{
        props:{
          translations:{
            phoneNumberLabel:"Phone Number"
          },
        }
       
      },

    formerrors: {
      msg: ""
    },
    beneficiary: {
      name: "",
      email: "",
      phone:"",
      phoneCountryCode :{countryCode:'',countryCallingCode:''}
    },
    saveBenbtn:false,
    AddBeneficiary:false,
    isPhoneValid:true,
    selectedPetitioner:null,
    sponsor:null,
    petitionersList:[], 
    sponsorList:[],

       
  }),
  props: {
    showActionBtn:{
      type:Boolean,
      default:true
    },
   //:visatype="visatype" :visasubtype="visasubtype" 
    visatype:null,
    visasubtype:null,
    petitioner:null,
    sponsorItem:null,
    selectedIItem:{
      type:Object,
      default:null
    },
    beneDetails:{
      type:Object,
      default:null
    },
    fromAdminIndDetails:{
      type:Boolean,
      default:false
    },
    fromSponsorLogin:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    userConformActivate(){
      let self =this;
      this.userConformErrorMsg = '';
      let postData ={"userId":'' , 'activateUserAndSendLink':true};
     
      if([1,2].indexOf(this.getUserRoleId)<=-1){
        postData = {"userId":'',"tenantId":'' ,'activateUserAndSendLink':true};
        postData['tenantId'] = this.checkProperty(this.getUserData, 'tenantId')
      }
      postData['userId'] = this.conformUserId;
      this.loading = true;
      this.$store.dispatch("commonAction", { "data": postData, "path": "users/send-activation-link" })
          .then(response => {
            self.userConform =false;
            self.userConform =false;
              
            setTimeout(() => {
              self.userConformMsg ='';
              self.conformUserId ='';
              self.loading = false;
              self.AddBeneficiary =false;
              self.closeAddBenPopUp();
              
            }, 100);
             
              this.showToster({ message:response.message, isError: false });
              
          }).catch((error) => {
            
            this.userConformErrorMsg = error;
              //this.showToster({ message:error, isError: true });
               this.loading = false;
              //this.userConform =false;
              // this.userConformMsg ='';
              // this.conformUserId ='';
              // this.loading = false;
          })
    },
    updatecellPhoneCountryCode(data){
      this.beneficiary['phoneCountryCode'] =data
    },
    updateSelection(){
     
      if(this.wiseSelection=='true'){
        this.anonymousUser = false;
   

      }else{
         this.anonymousUser = true;
        //  this.beneficiary.email='';
        // this.beneficiary.phone =''
        // this.beneficiary.phoneCountryCode = {countryCode:'',countryCallingCode:''};
      }
     
    // this.resetForm();
    },
    setPetDetails(selectedPetitioner=null){
      
      this.selectedPetitioner =selectedPetitioner
    },
    addNewBeneficiary(){
      this.userConformErrorMsg ='';
      this.userConformMsg = '';
      this.userConform =false;
      this.conformUserId ='';
      this.loading =false

      this.selectedPetitioner=null;
      this.beneficiary = {
      firstName:'',
      lastName:'',  
      name: "",
      email: "",
      phone:"",
      phoneCountryCode :{countryCode:'',countryCallingCode:''}
    }
    Object.assign(this.formerrors, {
                  msg: ''  });
   
    this.AddBeneficiary = true;
   this.$validator.reset();
   this.isPhoneValid =true;
   this.saveBenbtn =false;
  

    },
    updatePhone(item) {
         
       this.isPhoneValid =true;
       
      if (item.isValid  ) {
        
       this.beneficiary.phoneCountryCode = {countryCode:item.countryCode,countryCallingCode:item.countryCallingCode};
       this.beneficiary.phone = item.nationalNumber;
       
      }else{
        if(this.count>5)
          this.isPhoneValid =false;
      }
      this.count++;
    },
    updatebeneficiary(){
      this.$validator.validateAll().then(result => {
        this.saveBenbtn =false;
        if (result) {
          let self =this;
  //          postData={
  //          // userId:this.selectedIItem._id,
  //          // name: this.selectedIItem.name,
  //          // phone:this.selectedIItem.phone,
  //           phoneCountryCode:  { 
  //             countryCode:this.selectedIItem.countryCode,
  //             countryCallingCode:this.selectedIItem.countryCallingCode
  //           },
  //           firstName: this.selectedIItem.firstName,
  //           middleName: this.selectedIItem.middleName,
  //           lastName: this.selectedIItem.lastName,
  //           fax:"",
  //           faxCountryCode: { 
  //             countryCode:"",
  //             countryCallingCode:""
  //           },
  //           roleId: this.selectedIItem.roleId,
  //           address: { 
  //             line1: "",
  //             line2: "",
  //             aptType: "",// STE, FLR 
  //             locationId: "",
  //             stateId: "",
  //             countryId: "",
  //             zipcode: ""
  //           },
           
  //          // defaultCaseAssignConfig: { subTypeIds: [4,5] }  //default assign case user //defaultCaseAssignConfig
  // }

          this.beneficiary = Object.assign(this.beneficiary,{"roleId":51});
          this.beneficiary['name'] =  this.beneficiary['firstName'].trim()+" "+this.beneficiary['lastName'].trim();
          this.beneficiary['firstName'] =  this.beneficiary['firstName'].trim();
          this.beneficiary['lastName'] =  this.beneficiary['lastName'].trim();
          this.beneficiary['name'] =  this.beneficiary['name'].trim();
          this.beneficiary['phone'] = this.beneficiary['phone'];
          this.beneficiary['phoneCountryCode']= this.beneficiary['phoneCountryCode'];
          this.beneficiary['countryCallingCode']= this.beneficiary['countryCallingCode'];
          this.saveBenbtn =true;
          let postData = this.beneficiary;
          if(this.checkProperty(this.selectedIItem,'_id')){
            postData['userId']= this.checkProperty(this.selectedIItem,'_id')
            postData['accountType'] =  "Individual"
            postData['accountSubType'] =  "Beneficiary"
          }
          if(this.selectedIItem == null){
            if(self.selectedPetitioner && _.has(self.selectedPetitioner ,"_id")){
                postData = Object.assign(postData,{ "companyId": self.selectedPetitioner['_id']})
            }
          }
          postData = Object.assign(postData,{ "checkDeleteOrInactive":true})
          let path= "/users/update"
          this.$store
            .dispatch("commonActionWithErrorData", {"data":postData ,"path":path})
            .then(response => {
              this.saveBenbtn =false;
              if (response.error) {
                Object.assign(this.formerrors, {
                  msg: response.error.message
                });
              } else {     
                this.AddBeneficiary =false;
                this.selectedBeneficiary =response
                this.showToster({message:response.message,isError:false });
                this.closeAddBenPopUp();
              }
              // this.$router.go('/beneficiaries');
            })
            .catch((error)=>{
              this.saveBenbtn =false;
              if(this.checkProperty(error, 'error','code') == 'ACTIVATE_USER_ACCOUNT'){
                 this.userConformErrorMsg ='';
                this.loading =false;
                this.userConformMsg = this.checkProperty(error,'msg');
                this.userConform =true;
                this.conformUserId = this.checkProperty(error, '_id');
              }else{
                this.saveBenbtn =false;
                //this.showToster({message:err,isError:true })
                Object.assign(this.formerrors, {
                  msg: error.message
                });

              }
              
              

            });
        }
      })
    },
    savebeneficiary() {
      this.$validator.validateAll().then(result => {

        this.saveBenbtn =false;
        if (result) {
          let self =this;
          this.beneficiary = Object.assign(this.beneficiary,{"roleId":51});
          this.beneficiary['name'] =  this.beneficiary['firstName'].trim()+" "+this.beneficiary['lastName'].trim();
          this.beneficiary['firstName'] =  this.beneficiary['firstName'].trim();
          this.beneficiary['lastName'] =  this.beneficiary['lastName'].trim();
          this.beneficiary['name'] =  this.beneficiary['name'].trim();
          this.saveBenbtn =true;
          let postData = this.beneficiary;
          if(this.checkProperty(this.selectedIItem,'_id')){
            postData['userId']= this.checkProperty(this.selectedIItem,'_id')
            postData['accountType'] =  "Individual"
            postData['accountSubType'] = "Beneficiary"
          }
          if(this.selectedIItem == null){
           // if(self.selectedPetitioner && _.has(self.selectedPetitioner ,"_id") && [2].indexOf(self.checkProperty(self.visatype,'id'))<0 && ([4].indexOf(self.checkProperty(self.visatype,'id'))<0||([4].indexOf(self.checkProperty(self.visatype,'id'))>-1&&[18].indexOf(self.checkProperty(self.visasubtype,'id'))<0))){
            if(self.selectedPetitioner && _.has(self.selectedPetitioner ,"_id") && [2].indexOf(self.checkProperty(self.visatype,'id'))<0){ 
            postData = Object.assign(postData,{ "companyId": self.selectedPetitioner['_id']})
            }
          }
          if([4].indexOf(self.checkProperty(self.visatype,'id'))>-1){
           // postData = Object.assign(postData,{ "companyId": self.sponsor['_id']})
               postData['companyId'] =  this.checkProperty(self.sponsor,'_id')
              postData['accountType'] = 'Individual';
              postData['accountSubType'] = "Beneficiary"
          }
          if(this.fromSponsorLogin){
              postData['companyId'] = this.$store.state.loginUserData.userId
              postData['accountType'] = 'Individual';
              postData['accountSubType'] = "Beneficiary"
          }
           // visatype h4 invite ben
         //  if([2].indexOf(self.checkProperty(self.visatype,'id'))>-1||([4].indexOf(self.checkProperty(self.visatype,'id'))> -1&&[18].indexOf(self.checkProperty(self.visasubtype,'id'))> -1)  ){
         
          if([2].indexOf(self.checkProperty(self.visatype,'id'))>-1){
              postData['accountType'] = 'Individual';
              postData['accountSubType'] = "Beneficiary"
            }
         
         
          let path= "/users/register"
          if(this.checkProperty(this.selectedIItem,'_id')){
            path= "/users/invite-temp-user-to-individual"
          }
          postData = Object.assign(postData,{ "checkDeleteOrInactive": true}) 
          this.$store
            .dispatch("commonActionWithErrorData", {"data":postData ,"path":path})
            .then(response => {
              this.saveBenbtn =false;
              if (response.error) {
             
                Object.assign(this.formerrors, {
                  msg: response.error.message
                });
              } else {
               
                this.AddBeneficiary = false;
                this.selectedBeneficiary =response

                if(this.checkProperty(this.selectedBeneficiary ,"_id")){
       
                       this.selectedBeneficiary = Object.assign(this.selectedBeneficiary ,{"accountType": postData['accountType']});

                }
                this.showToster({message:response.message,isError:false });
                this.closeAddBenPopUp();
              }

              // this.$router.go('/beneficiaries');
            })
            .catch((error)=>{
              this.saveBenbtn =false;
              if(this.checkProperty(error, 'error','code') == 'ACTIVATE_USER_ACCOUNT'){
                 this.userConformErrorMsg ='';
                this.loading =false;
                this.userConformMsg = this.checkProperty(error,'msg');
                this.userConform =true;
                this.conformUserId = this.checkProperty(error, '_id');


                

              }else{
                this.saveBenbtn =false;
                //this.showToster({message:err,isError:true })
                Object.assign(this.formerrors, {
                  msg: error.message
                });

              }
              
              

            });
        }
      });
    },
    searchspnsr(searchText=''){
      let _self =this;
      this.selectedBeneficiary =null;
      this.sponsor =null;
      let self =this;
    clearTimeout(self.debounce)
    self.debounce = setTimeout(() => {
        self.getSponserForCase(self ,searchText);
      }, 900)
    },
    searchPet(searchText){
        let _self =this;
    
    this.enableAddNewpet =false;
    let filteredData =[];
    _.forEach(_self.petitionersList ,(item)=>{
            if( item && ( _.has(item ,'name') || _.has(item ,'email')  )){

                        if((_.has(item ,'name') && item['name'].includes(searchText)) || (_.has(item ,'email') && item['email'].includes(searchText)) ){
                        filteredData.push(item)
                        }else{
                        return false;
                        }

            }else{
                return false;
            }
            
        
        })
    if( (filteredData.length<=0 || !searchText )){

        //this.enableAddNewpet =true;
    // this   this.addNewPete = true;
        this.getPetitioners( true , searchText);
    }
        
    },
    getPetitioners(callFromSerch=false,searchText='' ) {
      
         let _self =this;
         let query ={
          "matcher":{
            "searchString": searchText,
            "statusIds": [],
            "countryIds": [],
            "stateIds": [],
            "locationIds": [],
            "createdDateRange": []
          },
        "sorting": { 	"path": "createdOn", 	"order": 1 	},
        "page": 1,
        "perpage": 25,
        getMasterData:true
	}
       
      
        this.$store.dispatch("getList",{data:query ,path:'/company/list'} ).then(response => {
            
            _self.petitionersList = response.list;

        }).catch((err)=>{
            this.petitionersList =[];
           
        })
    },
    addNewPet(){
       this.$emit("openAddpetPopUp" );
    },
    addSoponser(){
      this.$emit("openAddSponserPopUp" );
    },
    closeAddBenPopUp(){
      let self =this;
      if(this.checkProperty(this.selectedBeneficiary ,"_id")){
       
        this.selectedBeneficiary = Object.assign(this.selectedBeneficiary ,{"anonymousUser": self.anonymousUser});

      }
      
        this.$emit("closeAddBenPopUp" ,this.selectedBeneficiary);
       // this.$emit("fileNewCase");

    },
    getSponserForCase(text=''){
      let postData = {
          "matcher": {
            "title": text,
            "statusList": [],
            "branchIds": [],
            "companyIds": [], // Required only for Tenant Admin and Branch Manager to list Beneficiaries
            "createdByIds": [],
            "createdDateRange": [],
            "roleIds": [51],
            "statusIds": [],
            "petitionTypeIds": [],
            "petitionSubTypeIds": [],
            "petitionCreatedDateRange": [],
            "petitionStatusIds": [],
            "getPetitionStats": true
          },
        "sorting": {
          "path": "createdOn", // invitedByName, updatedOn, name, email, phone, statusName, roleName
          "order": 1
        },
        "page": 1,
        "perpage": 1000000,
        "getMasterData": true,
        "getBeneficiaryList": true, // Required only for Tenant Admin and Branch Manager to list Beneficiaries
        "branchId": "", // Required when 'getMasterData' is true and roleIds are [4, 5, 6, 7, 8, 9, 10, 11]
        "companyId": "" // Required when 'getMasterData' is true and roleIds are [50, 51]
	};
  this.enableAddNewBenTag =false;
  if([4].indexOf(this.checkProperty(this.visatype,'id')) >-1 || (this.isPetitioner == false || this.isPetitioner == 'false')){
    postData['matcher']['accountType'] = 'Individual';
    postData['matcher']['accountSubType'] = 'Sponsor';
  }
       this.$store
        .dispatch("petitioner/getbeneficiaries", postData)
        .then(response => {
          this.sponsorList = response.list;
        
          let filteredData =[];
       _.forEach(this.sponsorList ,(item)=>{
                if( item && ( _.has(item ,'name') || _.has(item ,'email')  )){

                         if((_.has(item ,'name') && item['name'].includes(text)) || (_.has(item ,'email') && item['email'].includes(text)) ){
                          filteredData.push(item)
                         }else{
                            return false;
                         }
                }else{
                  return false;
                }
         })

         if(filteredData.length<=0){
           this.enableAddNewBenTag =true;
         }
         let  sponsorList = _.cloneDeep(this.sponsorList);
         this.sponsorList =[];
         _.forEach(sponsorList, (item)=>{
          if(this.checkProperty(item,'name')){
            if(this.checkProperty(item ,'email') ){
              item['name'] =  item['name']+" ("+item['email']+")"
            }
            this.sponsorList.push(item);
          }
        
        })


          })

    },
  },
  mounted() {
   if(this.beneDetails !=null && this.selectedIItem!=null){
    setTimeout(()=>{
      this.beneficiary.firstName = this.checkProperty(this.beneDetails,'firstName')
      this.beneficiary.lastName = this.checkProperty(this.beneDetails,'lastName')
      this.beneficiary.phone = this.checkProperty(this.beneDetails,'phone')
      this.anonymousUser = this.checkProperty(this.beneDetails,'tempUser');
      this.beneficiary.email =  this.checkProperty(this.beneDetails,'email')
      this.beneficiary['phoneCountryCode'].countryCode = this.checkProperty(this.beneDetails,'phoneCountryCode','countryCode')
      this.beneficiary['phoneCountryCode'].countryCallingCode = this.checkProperty(this.beneDetails,'phoneCountryCode','countryCallingCode')
      
      this.selectedPetitioner =this.checkProperty(this.beneDetails,'petitionerDetails')
    },10)
    if(([3,50].indexOf(this.getUserRoleId) <= -1) && this.selectedIItem !=null){    
      this.editEmailTrue = true;
    }
  if(([3,50].indexOf(this.getUserRoleId) > -1) && this.selectedIItem !=null){
    this.editEmailTrue = false;
  }
    }
  
    // if(this.selectedIItem != null ){
     
    //   setTimeout(()=>{
    //   if(this.checkProperty(this.selectedIItem,'firstName') ){
    //     this.beneficiary.firstName = this.checkProperty(this.selectedIItem,'firstName')
    //   }
    //   if(this.checkProperty(this.selectedIItem,'lastName')){
    //     this.beneficiary.lastName = this.checkProperty(this.selectedIItem,'lastName')
    //   }
    //   if(this.checkProperty(this.selectedIItem,'email')){
    //     this.beneficiary.email = this.checkProperty(this.selectedIItem,'email')
    //   }
    //   if(this.checkProperty(this.selectedIItem,'phone')){
    //     this.beneficiary.phone = this.checkProperty(this.selectedIItem,'phone')
    //   }
    //   if(this.checkProperty(this.selectedIItem,'phoneCountryCode','countryCode')){
    //     this.beneficiary['phoneCountryCode'].countryCode = this.checkProperty(this.selectedIItem,'phoneCountryCode','countryCode')
    //   }
    //   if(this.checkProperty(this.selectedIItem,'phoneCountryCode','countryCallingCode')){
    //     this.beneficiary['phoneCountryCode'].countryCallingCode = this.checkProperty(this.selectedIItem,'phoneCountryCode','countryCallingCode')
    //   }
    //   if(this.checkProperty(this.selectedIItem,'petitions') || this.checkProperty(this.selectedIItem,'perms')){
    //     let beneficiaryEmailList = []
    //     let beneficiaryemail = ''
    //     _.forEach(this.selectedIItem['petitions'],(item)=>{
    //       if(_.has(item,'email')){
    //         beneficiaryEmailList.push(item)
    //       }
    //     })
    //     _.forEach(this.selectedIItem['petitions'],(item)=>{
    //       if(_.has(item,'email')){
    //         beneficiaryEmailList.push(item)
    //       }
    //     })
    //     if(this.checkProperty(beneficiaryEmailList,'length')){
    //       //alert(beneficiaryEmailList)
    //       beneficiaryEmailList= _.orderBy(beneficiaryEmailList, 'updatedOn' ,'desc');
    //       _.forEach(beneficiaryEmailList,(item)=>{
    //         beneficiaryemail = item.email
    //         return false;
    //       })
    //       if(beneficiaryemail != ''){
    //         this.beneficiary.email = beneficiaryemail
    //       }
    //     }
    //   }
    // },10)
    // }
    this.selectedBeneficiary =null;
    this.addNewBeneficiary();
   
    if([4].indexOf(this.checkProperty(this.visatype,'id')) >-1){
      this.getSponserForCase();
    }else{
      this.getPetitioners();
    }
    this.selectedPetitioner =this.petitioner;
    this.AddBeneficiary =true;
    this.count =0;
      this.sponsor = this.sponsorItem;
      this.selectedPetitioner =this.petitioner;

  }
};
</script>